import { render } from "./InferenceStatus.vue?vue&type=template&id=09826737&scoped=true"
import script from "./InferenceStatus.vue?vue&type=script&lang=js"
export * from "./InferenceStatus.vue?vue&type=script&lang=js"

import "./InferenceStatus.vue?vue&type=style&index=0&id=09826737&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09826737"]])

export default __exports__